module.exports = __webpack_public_path__ + "static/media/010-Begruessen_ID_1.9f808f19.mp3";